import { List } from 'immutable';
import { addToKeyPath, isLogicGroup, removeEmptyChildGroups } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { getLogicGroupConditionsSize } from '../filterQueryFormat/logic/LogicGroup';
import { And } from '../filterQueryFormat/logic/FilterLogicGroup';
import { isOperator } from '../filterQueryFormat/operator/Operator';
export const initialState = {
  internalDraftValue: undefined,
  internalDraftValueBeforeEdit: undefined,
  externalOriginalValue: undefined,
  isLoadingViewerData: true,
  hasLoadedEditorData: false,
  isLoadingFields: false,
  isFieldSelectMode: false,
  selectedObjectType: undefined,
  selectedFilterFamily: undefined,
  selectedFilterFamilyGroup: undefined,
  conditionPathToChangeFieldFor: undefined,
  conditionToRefineKeyPath: undefined,
  draftCondition: undefined,
  selectedCategory: undefined,
  selectedViewerGroupIndex: undefined,
  viewerConditionIdToHighlight: undefined,
  viewerConditionToDelete: undefined,
  viewerConditionToDeleteHovered: undefined,
  viewerClonedGroupIndex: undefined,
  viewerFilterSelected: undefined,
  isInEditMode: false,
  isEditorClosed: true,
  isInTestFilters: false,
  evaluatingFiltersForAll: false,
  filterInsights: undefined,
  testFiltersSelectedObjectId: undefined,
  testFiltersStatus: undefined,
  requiredIdsByAssetFamily: undefined,
  nullValueState: {
    showIncludeObjectsWithNoValueSetByOperator: {},
    defaultNullValueByOperator: {}
  }
};
export const utils = {
  createBlankAndGroup: filterFamily => {
    return And.of().merge({
      filterFamily
    });
  },
  addFilterInsightsIds: (logicGroup, firstIndex = 1) => {
    if (!logicGroup) {
      return {
        newCondition: undefined,
        nextIndex: firstIndex
      };
    }
    let filterInsightsId = firstIndex;
    const newFilterInsightsId = filterInsightsId++;
    const newConditions = logicGroup.conditions.map(condition => {
      if (isLogicGroup(condition)) {
        const {
          newCondition,
          nextIndex
        } = utils.addFilterInsightsIds(condition, filterInsightsId);
        filterInsightsId = nextIndex;
        return newCondition;
      } else if (isOperator(condition)) {
        return condition.set('filterInsightsId', filterInsightsId++);
      }
      return condition;
    });
    const {
      newCondition: newRefinements,
      nextIndex
    } = utils.addFilterInsightsIds(logicGroup.refinements, filterInsightsId);
    filterInsightsId = nextIndex;
    const newLogicGroup = logicGroup.merge({
      filterInsightsId: newFilterInsightsId,
      conditions: newConditions,
      refinements: newRefinements
    });
    return {
      newCondition: newLogicGroup,
      nextIndex: filterInsightsId
    };
  }
};
const resetFilterFamilySelect = {
  selectedFilterFamily: undefined,
  selectedFilterFamilyGroup: undefined,
  selectedObjectType: undefined,
  conditionToRefineKeyPath: undefined,
  conditionPathToChangeFieldFor: undefined,
  selectedCategory: undefined
};
const resetInternalFilterValue = {
  draftCondition: undefined,
  viewerFilterSelected: undefined
};
export const SegmentationFiltersInstanceReducer = (state, action) => {
  switch (action.type) {
    case 'loadingViewerData':
      return Object.assign({}, state, {
        isLoadingViewerData: action.payload
      });
    case 'hasLoadedEditorData':
      return Object.assign({}, state, {
        hasLoadedEditorData: action.payload
      });
    case 'requiredIdsByAssetFamily':
      return Object.assign({}, state, {
        requiredIdsByAssetFamily: action.payload
      });
    case 'internalDraftValue':
      {
        const {
          newCondition: internalDraftValue
        } = utils.addFilterInsightsIds(action.payload);
        return Object.assign({}, state, {
          internalDraftValue
        });
      }
    case 'setCategory':
      return Object.assign({}, state, {
        selectedCategory: action.payload.category,
        selectedFilterFamily: undefined,
        selectedFilterFamilyGroup: undefined
      });
    case 'addFilter':
      {
        const {
          filterFamilyInfo,
          parentGroupKeyPath,
          selectedObjectType
        } = action.payload;
        const internalDraftValue = removeEmptyChildGroups(state.internalDraftValue);
        const viewerGroupIndex = parentGroupKeyPath.get(0);
        const newState = Object.assign({}, state, {
          internalDraftValue,
          draftCondition: {
            conditionPath: parentGroupKeyPath,
            filterFamily: filterFamilyInfo ? filterFamilyInfo.filterFamily : undefined,
            isAddingNew: true
          },
          isFieldSelectMode: true,
          isEditorClosed: false
        }, resetFilterFamilySelect, {
          selectedObjectType,
          selectedViewerGroupIndex: viewerGroupIndex
        });
        const shouldShowFields = filterFamilyInfo &&
        // this checks if filter family is not an association
        filterFamilyInfo.filterFamily !== selectedObjectType.filterFamily;
        if (shouldShowFields) {
          newState.selectedFilterFamily = filterFamilyInfo;
          newState.isLoadingFields = true;
        }
        return newState;
      }
    case 'cancelAddFilter':
      return Object.assign({}, state, {
        draftCondition: undefined,
        isFieldSelectMode: false,
        selectedCategory: undefined,
        viewerFilterSelected: undefined
      });
    case 'editFilter':
      {
        const internalDraftValue = removeEmptyChildGroups(state.internalDraftValue);
        return Object.assign({}, state, {
          internalDraftValue,
          draftCondition: {
            conditionPath: action.payload.conditionPath,
            filterFamily: action.payload.filterFamily,
            isAddingNew: false
          },
          isFieldSelectMode: false,
          viewerConditionToDelete: undefined,
          isEditorClosed: false
        });
      }
    case 'addFilterGroup':
      {
        const filterFamily = action.payload;
        const newFilterGroup = utils.createBlankAndGroup(filterFamily);
        const {
          newCondition: internalDraftValue
        } = utils.addFilterInsightsIds(addToKeyPath(List(), newFilterGroup, state.internalDraftValue, action.payload));
        const numberOfTopLevelGroups = state.internalDraftValue && getLogicGroupConditionsSize(state.internalDraftValue) || 0;
        const conditionPath = List([numberOfTopLevelGroups]);
        const internalDraftValueBeforeEdit = !state.isInEditMode ? state.internalDraftValue : state.internalDraftValueBeforeEdit;
        return Object.assign({}, state, {
          isFieldSelectMode: true,
          isInEditMode: true,
          isEditorClosed: false,
          draftCondition: {
            conditionPath,
            filterFamily: undefined,
            isAddingNew: true
          },
          internalDraftValue,
          internalDraftValueBeforeEdit
        }, resetFilterFamilySelect, {
          selectedObjectType: {
            filterFamily,
            isObjectOwnFilterBranch: true
          },
          selectedViewerGroupIndex: numberOfTopLevelGroups
        });
      }
    case 'selectField':
      {
        const {
          newCondition: internalDraftValue
        } = utils.addFilterInsightsIds(action.payload.internalDraftValue);
        return Object.assign({}, state, {
          isFieldSelectMode: false,
          internalDraftValue,
          draftCondition: {
            conditionPath: action.payload.conditionPath,
            filterFamily: action.payload.filterFamily,
            isAddingNew: false
          }
        }, resetFilterFamilySelect, {
          conditionPathToChangeFieldFor: undefined,
          selectedCategory: undefined
        });
      }
    case 'fieldSelectMode':
      return Object.assign({}, state, {
        isFieldSelectMode: action.payload
      }, resetFilterFamilySelect);
    case 'resetEditor':
      {
        var _action$payload$inter, _action$payload;
        const internalDraftValue = (_action$payload$inter = (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.internalDraftValue) !== null && _action$payload$inter !== void 0 ? _action$payload$inter : state.internalDraftValue;
        const isInEditMode = action.payload && action.payload.shouldLeaveEditorOpen || false;
        const internalDraftValueBeforeEdit = isInEditMode ? state.internalDraftValueBeforeEdit : undefined;
        return Object.assign({}, state, {
          isFieldSelectMode: false,
          viewerConditionToDelete: undefined,
          isInEditMode,
          internalDraftValue,
          internalDraftValueBeforeEdit
        }, resetInternalFilterValue, resetFilterFamilySelect);
      }
    case 'nullValueState':
      return Object.assign({}, state, {
        nullValueState: action.payload
      });
    case 'refineFilter':
      return Object.assign({}, state, {
        isFieldSelectMode: true,
        conditionToRefineKeyPath: action.payload.conditionToRefineKeyPath,
        selectedFilterFamily: action.payload.filterFamilyInfo,
        isLoadingFields: true
      });
    case 'filterFamily':
      return Object.assign({}, state, {
        selectedFilterFamily: action.payload.filterFamilyInfo,
        isLoadingFields: true
      });
    case 'filterFamilyGroup':
      return Object.assign({}, state, {
        selectedFilterFamilyGroup: action.payload.filterFamilyGroup
      });
    case 'fieldsLoaded':
      return Object.assign({}, state, {
        isLoadingFields: false
      });
    case 'viewerDeleteCondition':
      {
        const {
          newCondition: internalDraftValue
        } = utils.addFilterInsightsIds(action.payload.internalDraftValue);
        return Object.assign({}, state, {
          internalDraftValue,
          viewerConditionToDelete: undefined
        });
      }
    case 'viewerConditionToDelete':
      return Object.assign({}, state, {
        viewerConditionToDelete: action.payload
      });
    case 'viewerConditionToDeleteHovered':
      return Object.assign({}, state, {
        viewerConditionToDeleteHovered: action.payload
      });
    case 'viewerClonedGroupIndex':
      {
        var _action$payload$inter2, _action$payload2;
        const {
          newCondition: internalDraftValue
        } = utils.addFilterInsightsIds((_action$payload$inter2 = (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.internalDraftValue) !== null && _action$payload$inter2 !== void 0 ? _action$payload$inter2 : state.internalDraftValue);
        const viewerClonedGroupIndex = action.payload ? action.payload.viewerClonedGroupIndex : undefined;
        return Object.assign({}, state, {
          viewerClonedGroupIndex,
          internalDraftValue,
          isFieldSelectMode: false
        }, resetFilterFamilySelect, resetInternalFilterValue);
      }
    case 'viewerConditionIdToHighlight':
      return Object.assign({}, state, {
        viewerConditionIdToHighlight: action.payload
      });
    case 'changeField':
      return Object.assign({}, state, {
        selectedFilterFamily: action.payload.filterFamilyInfo,
        conditionPathToChangeFieldFor: action.payload.conditionPath,
        isFieldSelectMode: true,
        isLoadingFields: true
      });
    case 'deleteCondition':
      {
        const {
          newCondition: internalDraftValue
        } = utils.addFilterInsightsIds(action.payload.internalDraftValue);
        return Object.assign({}, state, {
          isFieldSelectMode: false,
          viewerConditionToDelete: undefined,
          internalDraftValue
        }, resetInternalFilterValue, resetFilterFamilySelect);
      }
    case 'editFilters':
      return Object.assign({}, state, {
        isInEditMode: true,
        isEditorClosed: false,
        internalDraftValueBeforeEdit: state.internalDraftValue
      });
    case 'hideEditor':
      return Object.assign({}, state, resetInternalFilterValue, {
        isEditorClosed: true
      });
    case 'externalOriginalValue':
      return Object.assign({}, state, {
        externalOriginalValue: action.payload
      });
    case 'discardChanges':
      return Object.assign({}, state, {
        isFieldSelectMode: false,
        viewerConditionToDelete: undefined,
        isInEditMode: false,
        internalDraftValue: state.internalDraftValueBeforeEdit,
        internalDraftValueBeforeEdit: undefined
      }, resetInternalFilterValue, resetFilterFamilySelect);
    case 'resetSelectedFilterCategory':
      if (action.payload && action.payload.resetSelectedFilterCategoryGroup) {
        return Object.assign({}, state, {
          selectedFilterFamily: undefined,
          selectedFilterFamilyGroup: undefined
        });
      }
      return Object.assign({}, state, {
        selectedFilterFamily: undefined
      });
    case 'viewerFilterSelected':
      return Object.assign({}, state, {
        viewerFilterSelected: action.payload
      });
    case 'showTestFilters':
      return Object.assign({}, state, {
        isInTestFilters: true
      });
    case 'hideTestFilters':
      return Object.assign({}, state, {
        isInTestFilters: false,
        testFiltersStatus: undefined,
        filterInsights: undefined
      });
    case 'evaluateFiltersForAll':
      return Object.assign({}, state, {
        evaluatingFiltersForAll: true,
        testFiltersSelectedObjectId: undefined,
        testFiltersStatus: undefined
      });
    case 'testFiltersObjectChanged':
      return Object.assign({}, state, {
        evaluatingFiltersForAll: false,
        testFiltersSelectedObjectId: action.payload,
        filterInsights: undefined
      });
    case 'onFilterInsightsUpdated':
      return Object.assign({}, state, {
        filterInsights: action.payload
      });
    case 'onTestFiltersUpdated':
      return Object.assign({}, state, {
        testFiltersStatus: action.payload
      });
    case 'selectedObjectType':
      return Object.assign({}, state, resetFilterFamilySelect, {
        selectedObjectType: action.payload
      });
    case 'selectedViewerGroupIndex':
      return Object.assign({}, state, {
        selectedViewerGroupIndex: action.payload
      });
    default:
      throw new Error(`No ${action.type} in the SegmentationFiltersInstanceReducer`);
  }
};